import { graphql } from "@opensea/graphql"
import { CollectionPreviewTooltipContentFragment } from "./CollectionPreviewTooltipContent.fragment"

export const CollectionPreviewTooltipFragment = graphql(
  `
    fragment CollectionPreviewTooltip on CollectionIdentifier {
      ...CollectionPreviewTooltipContent
    }
  `,
  [CollectionPreviewTooltipContentFragment],
)
